/* eslint-disable */
import axios from './axios';
import utils from '../lib/utils';

export default {
  axios,
  // 获取用户收货地址详情
  getUserAddressById(params) {
    return axios.get(`/onlineDrug/address/getAddressInfoById?${utils.exchangeParams(params)}`);
  },
  //获取订单的所有快递
  getQueryExpress(params) {
    return axios.get(`/Prescription/queryExpress?${utils.exchangeParams(params)}`);
  },
  //判断批次是否同一
  getExamine(orderNum) {
    return axios.get(`Prescription/getExamine?orderNum=${orderNum}`);
  },

  // 获取用户处方列表
  getUserRecipeList(params) {
    // return axios.post('/onlineDrug/recipe/getUserRecipeList', params);
    return axios.post('/Prescription/PrescriptionList', params);

    // /Prescription/PrescriptionList
  },

  // 获取用户处方详情
  getRecipeInfo(params) {
    // return axios.post('/onlineDrug/recipe/getRecipeInfo', params);
    // return axios.post('/onlineDrug/recipe/getRecipeInfoList', params); // 2020.7.20 增加多处方展示功能
    return axios.post('/Prescription/getPrescriptionList', params); // 2022.2.17 增加多处方展示功能
  },
  // 提交处方支付订单
  submitPayOrder(params) {
    return axios.post('/onlineDrug/recipeOrder/submitPayOrder', params);
  },
  // 获取处方订单详情
  getRecipeOrderInfo(params) {
    return axios.post('/onlineDrug/recipe/getRecipeOrderInfo', params);
  },

  // 获取问诊单接口
  getQuestionnaire(params) {
    return axios.post('/onlineDrug/getPatientQuestionnaire', params);
  },
  // 提交问诊单接口
  submitConsultationOrder(params) {
    return axios.post('/onlineDrug/recipeOrder/submitConsultationOrder', params);
  },

  // 单独页面提交问诊单接口
  getQuestionnaireByOrderCode(params) {
    return axios.post('/onlineDrug/getPatientQuestionnaireByOrderCode', params);
  },

  // 更新问诊单接口
  updatetPatientQuestionnaire(params) {
    return axios.post('/onlineDrug/updatetPatientQuestionnaireByOrderCode', params);
  },

  // 获取医生赠送列表
  getDoctorPresentList(params) {
    return new Promise((resolve, reject) => {
      axios.get(`/doctorController/queryThankList?${utils.exchangeParams(params)}`).then(
        (res) => {
          resolve(res.data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },

  saveDoctorThank(data) {
    return axios.post('/doctorController/saveDoctorThank', data);
  },
};
